module.exports = __webpack_public_path__ + "img/tag_jinyong@2x.9892e352.png";